import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfig } from 'src/app/config/config';

@Injectable({
    providedIn: 'root'
  })
  export class JobHistoryBpsService {
  
    private pathApi = this.config.setting['pathApi'] + "bps/jobHistory/";
    private headers = new HttpHeaders({'Content-Type': 'application/json'});
    
    constructor(private http: HttpClient, private config: AppConfig) {
  
    }
    
    getAll(obj: any) {
        return this.http.post<any>(`${this.pathApi}getAll`, obj, {headers: this.headers, observe: 'response'});
    }
    download(data : any){
      return this.http.post<any>(`${this.pathApi}downloadFile`, data, {headers: this.headers, observe: 'response'});
    }
}